__turbopack_context__.v({
  "inner": "TopBar-module__r-Jwbq__inner",
  "link": "TopBar-module__r-Jwbq__link",
  "links": "TopBar-module__r-Jwbq__links",
  "slogan": "TopBar-module__r-Jwbq__slogan",
  "spaced": "TopBar-module__r-Jwbq__spaced",
  "topbar": "TopBar-module__r-Jwbq__topbar",
});
